import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import cookie from '../../../core/helpers/cookie';
import { useSelector } from '../../../core/redux/store';
import Button from '../Button';

type Props = {
  className?: string;
  size?: 'small' | 'medium' | 'large' | undefined;
};
export const VisitStandardWebsiteButton = ({ className, size = 'small' }: Props) => {
  const { t } = useTranslation('component');
  const affiliateId = useSelector((state) => state.booking.affiliate?.id);
  const { replace } = useRouter();

  if (process.env.NEXT_PUBLIC_FEATURE_FLAG_PARTNERSHIP_PARAMETER !== 'true') return null;
  if (!affiliateId) return null;

  const handleDeleteAffiliateId = () => {
    cookie.affiliate_id.remove();
    replace('/', undefined, { shallow: true });
  };

  return (
    <Button
      onClick={handleDeleteAffiliateId}
      type="button"
      color="transparent"
      textColor="red"
      border
      borderColor="red"
      rounded
      size={size}
      className={className}
    >
      <span className="mx-4 my-1 block text-center text-sm font-bold text-orange-700">
        {t('visit_standard_website_button.title')}
      </span>
    </Button>
  );
};

export default VisitStandardWebsiteButton;
